import { X } from "lucide-react";
import { PICTURES, pic } from "@/lib/pictures";

export const PictureGrid = ({ value, onChange, testId = "picture", big = false }) => {
  const add = (id) => value.length < 3 && onChange([...value, id]);
  return (
    <div>
      <div className="flex items-center gap-2 mb-3" data-testid={`${testId}-sequence`}>
        {[0, 1, 2].map((n) => {
          const p = value[n] && pic(value[n]);
          return (
            <div key={n} className={`${big ? "w-16 h-16" : "w-12 h-12"} rounded-2xl border-2 border-dashed grid place-items-center ${p ? "border-[#2C4A3E] bg-white" : "border-[#D6CDB4]"}`}>
              {p ? <p.Icon className={big ? "w-8 h-8" : "w-6 h-6"} style={{ color: p.color }} /> : <span className="text-stone-400 text-sm">{n + 1}</span>}
            </div>
          );
        })}
        {value.length > 0 && <button type="button" onClick={() => onChange([])} data-testid={`${testId}-clear`} aria-label="Start over" className="ml-1 p-2 rounded-full hover:bg-[#F1EADB] text-stone-500"><X className="w-4 h-4" /></button>}
      </div>
      <div className="grid grid-cols-3 gap-2 max-w-xs">
        {PICTURES.map((p) => (
          <button type="button" key={p.id} onClick={() => add(p.id)} disabled={value.length >= 3} aria-label={p.label} data-testid={`${testId}-${p.id}`}
            className={`${big ? "h-20" : "h-14"} rounded-2xl bg-white border border-[#E6DEC3] grid place-items-center hover:border-[#2C4A3E] hover:scale-[1.03] active:scale-95 transition-transform disabled:opacity-50`}>
            <p.Icon className={big ? "w-10 h-10" : "w-7 h-7"} style={{ color: p.color }} />
          </button>
        ))}
      </div>
    </div>
  );
};
